import {lazy} from 'react'

const WebRoutes = [
    {
        path: '/',
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/Home'))
    },  {
        path: '/',
        layout: 'WebLayout',
        component: lazy(() => import('@src/views/web/Products'))
    },
    {
        path: '/login',
        component: lazy(() => import('@src/views/web/authentication/Login')),
        layout: 'BlankLayout'
    },
    {
        path: '/about-us',
        component: lazy(() => import('@src/views/web/AboutUs')),
        layout: 'WebLayout'
    },
    {
        path: '/contact-us',
        component: lazy(() => import('@src/views/web/ContactUs')),
        layout: 'WebLayout'
    },
    {
        path: '/questions',
        component: lazy(() => import('@src/views/web/QuestionsPage')),
        layout: 'WebLayout'
    },
    {
        path: '/products/category/:slug',
        component: lazy(() => import('@src/components/web/home/Category/ProductCategory')),
        layout: 'BlankLayout'
    },
    {
        path: '/search',
        component: lazy(() => import('@src/components/web/home/Products')),
        layout: 'BlankLayout'
    },
    {
        path: '/services/category/:slug',
        component: lazy(() => import('@src/components/web/home/ProductSinglePage')),
        layout: 'BlankLayout'
    },
    {
        path: '/gallery',
        component: lazy(() => import('@src/views/web/Gallery')),
        layout: 'WebLayout'
    },

    {
         path: '/rules',
         component: lazy(() => import('@src/views/web/Rules')),
         layout: 'WebLayout'
     },
    {
        path: '/products-categories/:slug',
        component: lazy(() => import('../../components/web/home/ProductCategories')),
        layout: 'WebLayout'
    },
    {
        path: '/services/:slug',
        component: lazy(() => import('../../components/web/home/ServicesPage')),
        layout: 'WebLayout'
    },
    //  {
    //      path: '/questions',
    //      component: lazy(() => import('@src/views/web/Questions')),
    //      layout: 'WebLayout'
    //  },
     {
         path: '/collaboration',
         component: lazy(() => import('@src/views/web/Employment')),
         layout: 'WebLayout'
     },
    //  {
    //      path: '/collaboration',
    //      component: lazy(() => import('@src/views/web/Collaboration')),
    //      layout: 'WebLayout'
    //  },
    {
        path: '/articles/:slug',
        component: lazy(() => import('@src/views/web/Articles')),
        layout: 'WebLayout'
    } ,
    {
        path: '/articles',
        component: lazy(() => import('@src/views/web/Articles')),
        layout: 'WebLayout'
    },
    {
        path: '/article/:slug',
        component: lazy(() => import('@src/views/web/Article')),
        layout: 'WebLayout'
    }
]

export default WebRoutes
